import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { EndpointsName, get } from "../../Auth";
import { WinCCMessage } from '../../types';

export const getWinCCInitialData = () => get<WinCCMessage[]>(EndpointsName.BBF, '/wincc').pipe(
    switchMap(data => of(...data)
    ));
